export default __webpack_public_path__ + "static/media/fa-solid-900.c2b7c032.woff2";